import { Ref, ref } from 'vue';
import { useLogger } from './useLogger';

const localStream: Ref<MediaStream | null> = ref(null);
const hasAudioPermission: Ref<boolean | null> = ref(null);

export const audioProps: MediaTrackConstraints = {
  autoGainControl: true,
  channelCount: 2,
  echoCancellation: true,
  noiseSuppression: true,
  sampleRate: 48000,
  sampleSize: 16,
};

export function useLocalStream() {
  const { log } = useLogger();
  // Function to initialize stream
  async function initStream(deviceId?: string) {
    try {
      log('Initializing local stream');
      cleanUpLocalStream();

      const audioConstraints: MediaTrackConstraints = { ...audioProps }; // Start with base audio props
      if (deviceId) {
        audioConstraints.deviceId = { exact: deviceId };
      }

      // Get user media permissions
      const stream = await navigator.mediaDevices.getUserMedia({
        audio: audioConstraints,
        video: false,
      });

      log('stream:', stream);
      hasAudioPermission.value = true;
      localStream.value = stream;
      log('Initialized local stream:', localStream.value);
    } catch (error) {
      // Handle the error properly (e.g., by setting an error state or re-throwing the error)
      console.error('Failed to initialize media stream:', error);
      hasAudioPermission.value = false;
      throw error;
    }
  }

  // Function to stop and clean up the stream
  function cleanUpLocalStream() {
    if (localStream.value) {
      log('Cleaning up local stream');
      localStream.value.getTracks().forEach((track) => track.stop());
      localStream.value = null;
    }
  }

  return {
    localStream,
    initStream,
    cleanUpLocalStream,
    hasAudioPermission,
  };
}
